import { Box, Text } from "@mantine/core";
import { IconFilter, IconFilterOff } from "@tabler/icons-react";
import clsx from "clsx";
import { ReactNode } from "react";

interface BreadcrumbProps {
  testPrefix?: string;
  text?: string;
  withFilter?: boolean;
  hasFilters?: boolean;
  isFilterOpened?: boolean;
  toggleFilter?: () => void;
  leftSection?: ReactNode;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  testPrefix = "",
  text = "",
  withFilter = false,
  hasFilters = false,
  isFilterOpened = false,
  leftSection,
  toggleFilter,
}) => {
  return (
    <Box h={40} w={"100%"} bg={"gray.8"} pos={"relative"}>
      {leftSection && (
        <div className="absolute text-gray left-2 top-1/2 -translate-y-1/2">
          {leftSection}
        </div>
      )}
      <Text
        fw={600}
        fz={"md"}
        lh={1.2}
        data-testid="breadcrumb"
        c={"yellow"}
        className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 max-w-[calc(100%-80px)] truncate text-center"
      >
        {text.toUpperCase()}
      </Text>
      {withFilter && (
        <Box
          data-testid={`${testPrefix}-filter`}
          className={clsx(
            "absolute right-2 top-1/2 -translate-y-1/2",
            hasFilters ? "text-white" : "text-gray"
          )}
          onClick={toggleFilter}
        >
          {isFilterOpened ? <IconFilterOff /> : <IconFilter />}
        </Box>
      )}
    </Box>
  );
};

export default Breadcrumb;
